<ng-container *ngIf="catalog">
    <hr class="divider"/>
    <div class="last-category">

        <div class="last-category__image">
            <img
                    *ngIf="catalog.picture; else noPhoto"
                    [src]="getImageUri(catalog.picture)"
                    [alt]="catalog.header"
                    loading="lazy"
            />
            <ng-template #noPhoto>
                <img [src]="noPhotoSrc" [alt]="catalog.header"     loading="lazy"
                />
            </ng-template>
        </div>

        <div class="last-category__content">
            <h2 class="last-category__title">{{ catalog.header }}</h2>

            <div class="last-category__features" *ngIf="catalog.description"
                 [style.--product-content-line-height]="contentLineHeight">
              <p [innerHTML]="catalog.description | safeHtml"></p>
            </div>

<!--            <div class="last-category__divider"></div>-->

            <div class="last-category__actions">
<!--                <button-->
<!--                        class="btn-black"-->
<!--                        [disabled]="!hasDiagrams"-->
<!--                        (click)="openDiagramsModal()"-->
<!--                >Диаграммы</button>-->
<!--                <button-->
<!--                        class="btn-light-gray"-->
<!--                        [disabled]="!hasCertificates"-->
<!--                        (click)="openCertificatesModal()"-->
<!--                >Сертификаты</button>-->
            </div>
        </div>
    </div>
</ng-container>

<div class="lc-modal-overlay" *ngIf="showDiagramsModal" (click)="closeDiagramsModal()">
    <div class="lc-modal" (click)="$event.stopPropagation()">
        <div class="lc-modal__header">
            <h3 class="lc-modal__title">Диаграмма для {{ catalog?.header }}</h3>
            <button class="lc-modal__close" (click)="closeDiagramsModal()">&#x2715;</button>
        </div>
        <div class="lc-modal__body">
            <div class="lc-modal__list-header">Название</div>
            <div class="lc-modal__list">
                <div class="lc-modal__item" *ngFor="let diagram of catalog?.diagrams">
                    <span class="lc-modal__item-name">{{ diagram.header }}</span>
                    <button class="btn-gray btn-gray--sm" (click)="download(diagram)">
                        Показать диаграмму
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Сертификаты -->
<div class="lc-modal-overlay" *ngIf="showCertificatesModal" (click)="closeCertificatesModal()">
    <div class="lc-modal" (click)="$event.stopPropagation()">
        <div class="lc-modal__header">
            <h3 class="lc-modal__title">Сертификаты для {{ catalog?.header }}</h3>
            <button class="lc-modal__close" (click)="closeCertificatesModal()">&#x2715;</button>
        </div>
        <div class="lc-modal__body">
            <div class="lc-modal__list-header">Название</div>
            <div class="lc-modal__list">
                <div class="lc-modal__item" *ngFor="let cert of catalog?.certificates">
                    <span class="lc-modal__item-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M9 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6L9 1z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 1v5h5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="lc-modal__item-name">{{ cert.header }}</span>
                    <div class="lc-modal__item-actions">
                        <button class="lc-modal__icon-btn" title="Копировать ссылку" (click)="copyLink(cert)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <rect x="5" y="5" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.2"/>
                                <path d="M3 11V3h8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
                            </svg>
                        </button>
                        <button class="lc-modal__icon-btn" title="Скачать" (click)="download(cert)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 2v8M5 7l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2 12h12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
